import React from 'react';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';
import Help from '../../../common/Help.jsx';
import ColorPicker from '../../../common/ColorPicker/DashboardColorPicker.jsx';
import Select from '../../../common/Select.jsx';
import DashboardIconSelect from '../../../common/icon_select/DashboardIconSelect.lazy.jsx';
import styles from '../base/CommonSettings.module.scss';
import { cloneDeep } from 'lodash'

function WorkflowDataStripWidgetSettingsRow({d, index, widgetId, datasets, datasetsKey, settingsDatasets}) {
    const setAttribute = useSetWidgetAttribute(widgetId)

    const updateVariableSetting = (key, index, value) => {
            const currentDatasets = cloneDeep(datasets)
            let dataset = {...datasets[index]};
            dataset[key] = value
            currentDatasets[index] = dataset;
            setAttribute(`settings.${datasetsKey}`, currentDatasets);
    };

    const currentDatasetsOptions = (settingsDatasets || []).filter((c) => c.group_by == 'fund').map((c) => ({value: c.value, label: c.label}))

    return (
        <>
            <label className={styles['settings-option']}>
            {I18n.t("name_item")}
            <input
                type="text"
                className="form-control"
                name="name_item"
                maxLength={70}
                data-index={index}
                value={d.name_item}
                onChange={(e) => updateVariableSetting("name_item", e.target.dataset.index, e.target.value)}
            />
            </label>
            <label className={styles['settings-option']}>
                <div className='d-flex'>
                    {I18n.t("dataset")}
                    {d.source && <Help text={I18n.t("workflow_data_strip_default_disable_dataset")} trigger="hover" className='' />}
                </div>
                <Select
                    options={currentDatasetsOptions}
                    value={d.dataset_id}
                    onChange={(value) => updateVariableSetting("dataset_id", index, value)}
                    disabled={d.source ? true : false}
                />
            </label>
            <label className={styles['settings-option']}>
            <div>{I18n.t("image")}</div>
            <DashboardIconSelect
                value={d.image}
                onChange={(value) => updateVariableSetting('image', index, value)}
            />
            </label>
            <label className={styles['settings-option']}>
                {I18n.t("background_color")}
                <ColorPicker value={d.background_color} onChange={(val) => updateVariableSetting("background_color", index, val)} />
            </label>
        </>
    )
}

export default WorkflowDataStripWidgetSettingsRow;
